module.exports = __webpack_public_path__ + "static/media/Matilde-min.0320e81c.png";